import { createSRPCClient } from "@srpc/core/client";
import * as transformer from "seroval";
import type { AppRouter } from "./routes/router";

export const rpc = createSRPCClient<AppRouter>({
  endpoint: "/api/srpc",
  transformer,
});
